var shpCustom = {

	cartItemsCountPanel: ".cart__count",

	shpProduct: null,
	shpCart: null,
	reloadEnabled: false,
	twoLevelZoom: false,
	
	baseURL: '',
	
	init: function() {
		shpCustom.baseURL = $('meta[name="shpBaseDir"]').attr('content');
		
	//-------------------------------------------------------------------------------------------------	
	//	cart
	//-------------------------------------------------------------------------------------------------	
		$('.add2CartButton').click(function(event) {
			event.preventDefault();
			shpCustom.cartItemAdd(this);
		});
		$('.add2CartButton').removeClass('d-none');
		
		$('[data-cart-item-quantity_group] [data-type=minus]').click(function(event) {
			event.preventDefault();
			shpCustom.setQuantity(this,-1);
		});
		$('[data-cart-item-quantity_group] [data-type=plus]').click(function(event) {
			event.preventDefault();
			shpCustom.setQuantity(this,1);
		});
		$('[data-cart-item-quantity_group] [data-type=remove]').click(function(event) {
			event.preventDefault();
			shpCustom.cartItemRemove(this);
		});
		
	//-------------------------------------------------------------------------------------------------	
	//	misc
	//-------------------------------------------------------------------------------------------------	
		// blog, collections
		$('#loadItemsList').click(function(event) {
			event.preventDefault();
			shpCustom.loadItemsList($(this).attr("href"));
		});
		
		// main Top Banner
		if ($('#mainTopBanner').length>0) {
			$('#mainMenuBar').addClass('transparent-menu');
		}
		
		// main Top Banner
		if ($('.bottomSlider').length>0) {
			$('.shop-features__line').addClass('no-line');
		}
		
		// magic with open modals, change href
		this.hrefToModal();
		$('button[data-target]').click(function() {
			location.href = $(this).data('target');
		});
		$('#shpCustomShowInfo').on('hidden.bs.modal',function(){ 
			$(this).find(".modal-title").text('');
			$(this).find(".modal-body").html('');	
		})

	//-------------------------------------------------------------------------------------------------	
	// check newsletter box
	//-------------------------------------------------------------------------------------------------	
		if (!shpCustom.getCookie('newsletter_box')) {
			$('#newsletter_modal').on('hidden.bs.modal', function (event) {
				shpCustom.setCookie('newsletter_box',1);	// valid for session
			})
			setTimeout(function(){
				$('#newsletter_modal').modal('show');
			}, 4000);
		}	
		$('#NewsletterModalForm').submit(function() {
			shpCustom.setCookie('newsletter_box',1,30);		// not sure if submition will be successfull
		}); 
		
		
	//-------------------------------------------------------------------------------------------------	
	// check Cookie information
	//-------------------------------------------------------------------------------------------------	
		if (!shpCustom.getCookie('cookies_box')) {
			$('#cookies_modal button').click(function() {
				$('#cookies_modal').hide();
				shpCustom.setCookie('cookies_box',1,30);		// close Cookie information for 30 days
			});
			$('#cookies_modal').show();
		}
		

	//-------------------------------------------------------------------------------------------------	
	//	customer section
	//-------------------------------------------------------------------------------------------------	
		// login / password reset-start
		$('.loginFormToggle').click(function(event) {
			event.preventDefault();
			$('.login-form').toggle();
		});
		
		// addresses
		// show/hide address form
		$('[data-target_item_form_id]').click(function(event) {
			event.preventDefault();
			$('[data-item_form_id]').hide();
			let form_id = $(this).data('target_item_form_id');
			$('[data-item_form_id='+form_id+']').show();
		});
		// confirm address removal
		$('#AddressRemoveConfirmation').on('show.bs.modal', function (event) {
			var button = $(event.relatedTarget);
			$(this).find('form').attr('action',button.data('target'))
		});
		$('#AddressRemoveConfirmation').on('hidden.bs.modal', function (event) {
			$(this).find('form').attr('action','#');
		});

		$('select[name="address[country]"]').each(function () {
			shpCustom.setSelectValue($(this));
		})
		
	//-------------------------------------------------------------------------------------------------	
	//	page-contact
	//-------------------------------------------------------------------------------------------------	
		if ($('.page-contact').length>0) {
			$('select[name="contact[store]"]').each(function () {
				shpCustom.setSelectValue($(this));
			})
			$('select[name="contact[language]"]').each(function () {
				shpCustom.setSelectValue($(this));
			})
		}
		
	//-------------------------------------------------------------------------------------------------	
	//	collection page / product list
	//-------------------------------------------------------------------------------------------------	
		if ($('.collection-page').length>0) {
			
			// filters
			$('#filters button.apply').click(function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyTagFilters();
			});
			
			$('#filters button.reset').click(function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyTagFilters(true);
			});
			
		}
		
	//-------------------------------------------------------------------------------------------------	
	//	search page
	//-------------------------------------------------------------------------------------------------	
		if ($('.search-page').length>0) {
			
			let query = shpCustom.getUrlParameter('q');
			if (query) {
				jQuery.each(query.split(/[\+\,\;]/), function(index, element) {
					console.log('|'+element+'|');
					
					$('#filters').find('input[type=checkbox][data-name="'+element.trim()+'"]').prop("checked",true);
				});
			}
			
			
			// filters
			$('#filters button.apply').click(function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyTagSearchFilters();
			});
			
			$('#filters button.reset').click(function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyTagSearchFilters(true);
			});
			
		}
		
	//-------------------------------------------------------------------------------------------------	
	//	product page
	//-------------------------------------------------------------------------------------------------	
		if ($('.product-page').length>0) {
			shpCustom.reloadEnabled = true;
			let product_handle = $('#product-object').data('handle');
			jQuery.getJSON("/products/"+product_handle+".js", function(product) {
				shpCustom.shpProduct = product;
				// get selected Variant ID
				shpCustom.shpProduct.selected_variant_id = $('#product-object').data('variant');
				jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
					if (element.id == shpCustom.shpProduct.selected_variant_id) {
						// get selected Variant position
						shpCustom.shpProduct.selected_variant_index = index;
					}
				});
				let selectedVariant = shpCustom.shpProduct.variants[shpCustom.shpProduct.selected_variant_index];
				
				if (shpCustom.shpProduct.options.length == 1)	{ // only one variant-option
					jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
						if (element.available == false) {
							let option_item = $('select[name=option1]').find('option[value="'+element.option1+'"]');
							option_item.html(option_item.html() + ' - ' + shpTheme.strings.soldoutProduct);							
						}
					});
				} else if (shpCustom.shpProduct.options.length == 2)	{ // two variant-option
					let current_option1 = selectedVariant.option1;
					let current_option2 = selectedVariant.option2;
					$('select[name=option2] option').prop('disabled',true);
					jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
						if (element.available == false && element.option2 == current_option2) {
							let option_item = $('select[name=option1]').find('option[value="'+element.option1+'"]');
							option_item.html(option_item.html() + ' - ' + shpTheme.strings.soldoutProduct);							
						}
						if (element.option1 == current_option1) {
							$('select[name=option2]').find('option[value="'+element.option2+'"]').prop('disabled',false);
						}
					});
				} else if (shpCustom.shpProduct.options.length == 3)	{ // three variant-option
					let current_option1 = selectedVariant.option1;
					let current_option2 = selectedVariant.option2;
					let current_option3 = selectedVariant.option3;
					$('select[name=option3] option').prop('disabled',true);
					jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
						if (element.available == false && element.option2 == current_option2 && element.option3 == current_option3) {
							let option_item = $('select[name=option1]').find('option[value="'+element.option1+'"]');
							option_item.html(option_item.html() + ' - ' + shpTheme.strings.soldoutProduct);							
						}
						if (element.option1 == current_option1 && element.option3 == current_option3) {
							$('select[name=option2]').find('option[value="'+element.option2+'"]').prop('disabled',false);
						}
						if (element.option1 == current_option1 && element.option2 == current_option2) {
							$('select[name=option3]').find('option[value="'+element.option3+'"]').prop('disabled',false);
						}
					});
				}
			});
			
			$('#product-images-zoom').click(function(event) {
				$(this).toggleClass('active');
				window.scrollTo(0, 0); 
			});
			
			$('#product-object .carousel-main .carousel-cell img').click(function(event) {
				$('#product-images-zoom .product-images-zoom-image-wrapper').html('<img src="'+$(this).data('original')+'" class="lazyload zoom-first-level"' + ( shpCustom.twoLevelZoom==true ? ' onclick="shpCustom.checkZoom(this,event);"' : '') + '>');
				
				$('#product-images-zoom').toggleClass('active');
				$('body').toggleClass('product-images-zoom');
			});
			
			$('#product-object .carousel-main .carousel-cell .click2ZoomButton').click(function(event) {
				$(this).siblings('img').click();
			});
				
		};
		
		$('.productOptionSelection').change(function () {
			shpCustom.updateVariantInfo($(this).data('index'), $(this).val());
		})
		
		$('input[name=productgroup]').change(function() {
			let target = $(this).val();
			if (target && target != '#') {
				window.location.href = shpCustom.baseURL + $(this).val();
			}
		});
		
		$('select[data-role=option]').change(function() {
			let option1 = $('select[name=option1]').val();
			let option2 = $('select[name=option2]').val();
			let option3 = $('select[name=option3]').val();
			
			shpCustom.reload2Variant(option1, option2, option3);
		});
		
		
	},
	
//-------------------------------------------------------------------------------------------------	
//	cookies
//-------------------------------------------------------------------------------------------------	
	setCookie: function (cname, cvalue) {
		var expires = "";
		var path = "path=/";
		if (arguments[2]) {
			var d = new Date();
			d.setTime(d.getTime() + (arguments[2]*24*60*60*1000));
			expires = "expires="+d.toGMTString()+"; ";
		}
		document.cookie = "SHP_" + cname + "=" + cvalue + "; " + expires + path;
	},
	
	getCookie: function (cname) {
		var name = "SHP_" + cname + "=";
		var ca = document.cookie.split(';');
		for(var i=0; i<ca.length; i++) {
			var c = ca[i].trim();
			if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
		}
		return "";
	},
	
	
//-------------------------------------------------------------------------------------------------	
//	misc
//-------------------------------------------------------------------------------------------------	

	// change a.href with href #modal_id (added in Theme Customization) to button witch opens that modal
	hrefToModal: function() {
		$('.modal').each(function () {
			let id = $(this).attr("id");
			$("a[href='#"+id+"']").each(function () {
				$(this).attr('href','#');
				$(this).attr('data-bs-toggle','modal');
				$(this).attr('data-bs-target','#'+id);
			});
		});
	},
	
	/**
	 *  @brief Loads next page of items. Should be bined to <a href="url2load"> button
	 *  
	 *  @param [in] url2load 	url to load next page (href)
	 *  
	 *  @details 
	 *  	- items are placed in #itemsList2Load-container (next are append to old one)
	 *  	- panel with loading - #itemsList2Load-count (old panel content is replaced by next)
	 *  
	 */
	loadItemsList: function(url2load) {
		$('body').addClass('itemsLoading');
		$.ajax({
			url: url2load,
			type: 'GET'
		}).done(function(data) {
			//console.log($(data).find('#itemsList2Load-container').html());
			$('#itemsList2Load-container').append($(data).find('#itemsList2Load-container').html());
			$('#itemsList2Load-count').html($(data).find('#itemsList2Load-count').html());

			$('#loadItemsList').click(function(event) {
				event.preventDefault();
				shpCustom.loadItemsList($(this).attr("href"));
			});
			$('body').removeClass('itemsLoading');
		});
	},
		
	getUrlParameter: function(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] === sParam) {
				return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
			}
    }
    return false;
	},
	
	setSelectValue: function(selectElement) {
		let selectValue = $(selectElement).data('default');
		if (selectValue) {
			$(selectElement).find('option').each(function() {
				if ($(this).text() == selectValue) {
					$(this).prop('selected',true);
					return false;
				}
			});
		}
	},
	
	showInfo: function (infoTitle, infoText) {
		if ($('#shpCustomShowInfo').length>0) {
			let infoModal = $('#shpCustomShowInfo');
			$(infoModal).find(".modal-title").text(infoTitle);
			$(infoModal).find(".modal-body").html(infoText);	
			$(infoModal).modal('show');
		} else {
			alert(infoTitle + ':' + String.fromCharCode(13,10) + infoText);
		}
	},
	
	
//-------------------------------------------------------------------------------------------------	
//	collection page / product list
//-------------------------------------------------------------------------------------------------	
	/**
	 *  @brief function to assign submit (read tag checkboxes and send request)
	 */
	applyTagFilters: function() {
		let filtersPanel = $('#filters');
		
		if (shpCustom.reloadEnabled && filtersPanel.data('collection_url')) {		

			let collectionURL = shpCustom.baseURL + filtersPanel.data('collection_url') + '/';
			let filtersList = [];
			let sort_url = '';
			
			if (arguments[0] !== true) {// true => reset filters
				filtersPanel.find('input[type=checkbox]').each(function(index) {
					if ($(this).prop('checked')) {
						filtersList.push($(this).val());
					}
				});
			}

			if (arguments[0] !== true) {	
				let sort_order = filtersPanel.find('input[name=sort_by]:checked').val();
				if (sort_order) {
					sort_url = '?sort_by='+sort_order;
				}
			}
			
			window.location.href = collectionURL + filtersList.join('+') + sort_url;
		}
	},

//-------------------------------------------------------------------------------------------------	
//	search page
//-------------------------------------------------------------------------------------------------	
	applyTagSearchFilters: function() {
		let filtersPanel = $('#filters');
		
		if (shpCustom.reloadEnabled) {		

			let searchURL = shpCustom.baseURL + '/search?type=prodcts&q=';
			let filtersList = [];
			
			if (arguments[0] !== true) {// true => reset filters
				filtersPanel.find('input[type=checkbox]').each(function(index) {
					if ($(this).prop('checked')) {
						filtersList.push($(this).data('name'));
					}
				});
			}
			
			window.location.href = searchURL + filtersList.join('+')
		}
	},
			
//-------------------------------------------------------------------------------------------------	
//	product
//-------------------------------------------------------------------------------------------------	
	reload2Variant: function (option1, option2, option3) {			
		
		let goodID_123 = null;	
		let goodID_12 = null;	
		
		let firstOption1ID = null;
		let firstOption2ID = null;
		let firstOption3ID = null;

		let selectedVariant = shpCustom.shpProduct.variants[shpCustom.shpProduct.selected_variant_index];
		jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
			if (!firstOption1ID && element.options[0] == option1) {
				firstOption1ID = element.id;
			}
			if (!firstOption2ID && element.options[1] == option2) {
				firstOption2ID = element.id;
			}
			if (!firstOption3ID && element.options[2] == option3) {
				firstOption3ID = element.id;
			}

			if (!goodID_12 && element.options[0] == option1 && element.options[1] == option2) {
				goodID_12 = element.id;
			}
			if (!goodID_123 && element.options[0] == option1 && element.options[1] == option2 && element.options[2] == option3) {
				goodID_123 = element.id;
			}
		});
		
		// console.log('goodID_123' + goodID_123);
		// console.log('goodID_12' + goodID_12);
		// console.log('firstOption1ID' + firstOption1ID);
		// console.log('firstOption2ID' + firstOption2ID);
		// console.log('firstOption3ID' + firstOption3ID);
		
		let goodID = ( goodID_123 ? goodID_123 : goodID_12);
		
		if (!goodID) {
			if (firstOption1ID) {
				goodID = firstOption1ID;
			} else if (firstOption2ID) {
				goodID = firstOption2ID;
			} else {
				goodID = firstOption3ID;
			}
		}			
		if (goodID) {
			//if (shpCustom.reloadEnabled) {
				window.location.href = shpCustom.baseURL + shpCustom.shpProduct.url + '?variant=' + goodID;
			//}
		}
	},

	/**
	 *  @brief from changed option calculate new selected Variant
	 *  
	 *  @param [in] optionID		option.position
	 *  @param [in] optionValue option value for Variant
	 *  @return Return description
	 *  
	 *  @details More details
	 */
	updateVariantInfo: function(optionID, optionValue) {
		let newVariant = false;
		let currentVariant = shpCustom.shpProduct.variants[shpCustom.shpProduct.selected_variant_index];
		let currentFeatures = {
			"option1": currentVariant.option1,
			"option2": currentVariant.option2,
			"option3": currentVariant.option3
		};
		// get clone of currentFeatures but with changed option
		let newFeatures = Object.assign({}, currentFeatures);
		newFeatures[optionID] = optionValue;
		
		jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
			if (element.option1 == newFeatures.option1 && element.option2 == newFeatures.option2 && element.option3 == newFeatures.option3) {
				newVariant = Object.assign({}, element);
			}
		});
		
		if (newVariant != false) {
			// price
			let moneyFormat = shpTheme.money.moneyFormat+"";
			$('#product-object .product-standard-price').html(moneyFormat.replace('{{amount}}',numeral(newVariant.price/100).format('0,0.00')));
			$('#product-object .product-compare-price').html(moneyFormat.replace('{{amount}}', numeral(newVariant.compare_at_price/100).format('0,0.00')));			
			
			// variant ID
			$('#product-object').attr('data-variant',newVariant.id);
			$('#product-object input[name=id]').val(newVariant.id);
			
			let Add2Cart = $('#product-object .add-to-cart');
			if (newVariant.available) {
				$(Add2Cart).prop("disabled",false);
				$(Add2Cart).html(shpTheme.strings.addToCart);
			} else {
				$(Add2Cart).prop("disabled",true);
				$(Add2Cart).html(shpTheme.strings.unavailableProduct);
			}
			
			if (newVariant.featured_image) {
				$('#product-object .product-gallery__slider .slick-slide').not('.slick-cloned').each(function () {
					if (newVariant.featured_image.id == $(this).data('src_id')) {
						//console.log($(this).data('slick-index'));
						$('.product-gallery__slider').slick('slickGoTo',$(this).data('slick-index'));
					}
				});
			}
		} else {
			shpCustom.showInfo(shpTheme.strings.unknownVariantTitle, shpTheme.strings.unknownVariantMessage);
		}
	},

	checkZoom: function(element, event) {
		event.preventDefault();
		event.stopPropagation();
		
		$(element).toggleClass(['zoom-first-level','zoom-second-level']);
	},
			

//-------------------------------------------------------------------------------------------------	
//	cart
//-------------------------------------------------------------------------------------------------	
	getCart: function() {
		jQuery.getJSON("/cart.js", function(cart) {
			shpCustom.shpCart = cart;
			
			shpCustom.updateCartInfo();
			
			$('.processCartWait').hide();
		});
	},

	updateCartInfo: function() {
		let moneyFormat = shpTheme.money.moneyFormat+"";
		
		// update summary data
		$(shpCustom.cartItemsCountPanel).text(shpCustom.shpCart.item_count);
		$('[data-cart-subtotal]').html(moneyFormat.replace('{{amount}}',numeral(shpCustom.shpCart.total_price/100).format('0,0.00')));
		if (shpCustom.shpCart.item_count==0) {
			$('.cartContent').addClass('empty');
		} else {
			$('.cartContent').removeClass('empty');
		}
		
		// update mini-cart panel
		let current_lines = [];
		if (Array.isArray(shpCustom.shpCart.items)) {
			$.each(shpCustom.shpCart.items, function( index, item ) {
				current_lines.push(item.variant_id);
				let cartLine = $('[data-cart-item-vid="'+item.variant_id+'"]');
				if ($(cartLine).length>0) {
					$(cartLine).find('[data-cart-item-quantity]').attr('data-cart-item-quantity',item.quantity);
					$(cartLine).find('[data-cart-item-quantity]').val(item.quantity);
				} else {
					shpCustom.newCartLine(item);
				}
			});
		}
		$('[data-cart-item]').not('.cartLineTemplate').each(function() {
			if (current_lines.indexOf($(this).data('cart-item-vid')) === -1) {
				$(this).remove();
			}
		});
	},

	setQuantity: function(element, step) {
		let sectionContainer = $(element).parents('[data-cart-item-quantity_group]');
		if (!$(sectionContainer).hasClass('section-disabled')) {
			let sectionInput = $(sectionContainer).find('input[name="quantity"]');
			let sectionlabel = $(sectionContainer).find('[data-cart-item-quantity_label]');
			let productSection = $(element).parents('[data-cart-item]');
			
			let result = $(sectionInput).val()*1 + step*1;
			if (result*1 <= 0) {
				result = 1;
			}
			$(sectionInput).val(result);
			
			if (result<=1) {
				$(sectionContainer).find('[data-type=minus]').prop("disabled",true);
			}	else {
				$(sectionContainer).find('[data-type=minus]').prop("disabled",false);
			}
			shpCustom.cartItemUpdate(productSection.data('cart-item-vid'), result, productSection.data('cart-item-title'));
			
			
			if (result < 10) {
				result = "0" + result;
			}
			$(sectionlabel).text(result);
			
		}
	},
	
	cartItemRemove: function(element) {
		let productSection = $(element).parents('[data-cart-item]');
		shpCustom.cartItemUpdate(productSection.data('cart-item-vid'), 0, productSection.data('cart-item-title'));		
	},

	cartItemAdd: function(element) {
		let cartForm = $(element).parents('form');
		let variant_id = $(cartForm).find('input[name="id"]').val();
		let variant_quantity = $(cartForm).find('input[name="quantity"]').val();
		
		$('.processCartWait').show();
		
		jQuery.ajax({
			type: "POST",
			url: "/cart/add.js",
			data: "quantity=" + (variant_quantity = variant_quantity || 1) + "&id=" + variant_id,
			dataType: "json",
			success: function (success_data) {
				shpCustom.getCart();
				$('.site-header-cart-side').addClass('active');
			},
			error: function (error_data, error_type) {
				shpCustom.cartUpdateError(error_data);
			},
			complete: function () {
				$('.processCartWait').hide();
			}
		});
	},
		
	cartItemUpdate: function(variant_id, variant_quantity, variant_title) {
	
		//$('.processCartWait').show();
		
		jQuery.ajax({
			type: "POST",
			url: "/cart/change.js",
			data: "quantity=" + (variant_quantity*1) + "&id=" + variant_id,
			dataType: "json",
			success: function (success_data) {
				if (variant_quantity==0) {
					$('[data-cart-item-vid='+variant_id+']').remove();
				} else if (success_data.items) {
					// check if update succeded
					$.each(success_data.items, function( index, item ) {
						if (variant_id == item.variant_id) {
							if (variant_quantity > item.quantity) {
								shpCustom.showInfo(shpTheme.strings.cartUpdateUnsuccessful, shpTheme.strings.productInventoryLevelTooLow);
							}								
						}
					});
				}
				shpCustom.shpCart = success_data;
				shpCustom.updateCartInfo();
			},
			error: function (error_data, error_type) {
				shpCustom.cartUpdateError(error_data);
			},
			complete: function () {
			}
		});
	},
	
	cartUpdateSuccess: function(success_data, sucess_info) {
	},

	cartUpdateError: function(error_data) {
		let error_info = error_data.responseJSON
		shpCustom.showInfo(error_info.message, error_info.description);
	},
	
	newCartLine: function(item) {
		let newLine = $('.cartLineTemplate').clone().insertBefore( $('.cartLineTemplate') );
		let moneyFormat = shpTheme.money.moneyFormat+"";
		
		$(newLine).attr('data-cart-item-key',item.key);
		$(newLine).attr('data-cart-item-url',item.url);
		$(newLine).attr('data-cart-item-title',item.title);
		$(newLine).attr('data-cart-item-vid',item.variant_id);
		
		$(newLine).find('[data-cart-item-quantity]').attr('data-cart-item-quantity',item.quantity);
		$(newLine).find('input[data-cart-item-quantity]').val(item.quantity);
		
		let newImagePath = item.image.replace(/(.*)\.(.*?)\?v=(.*?)$/, '$1_150x150_crop_center.$2?v=$3');		
		$(newLine).find('img[data-cart-item-image]').attr('src',newImagePath);
		
		$(newLine).find('[data-cart-item-url]').attr('href',item.url);
		$(newLine).find('[data-cart-item-title]').html(item.title);
		$(newLine).find('[data-cart-item-product-title]').html(item.product_title);

		// variant options
		if (item.product_has_only_default_variant==false && item.options_with_values) {
			let optionsContainer = $(newLine).find('[data-cart-item-variant_options]');
			if (optionsContainer.length>0) {
				//console.log(optionsContainer.length);
				let optionTemplate = optionsContainer.find('[data-cart-item-variant_option]').detach();
				if (optionTemplate) {
					let newOption;
					jQuery.each(item.options_with_values, function(index, element) {
						newOption = optionTemplate.clone().appendTo(optionsContainer);
						$(newOption).html(element.name + ': ' + element.value);
					});
				}
			}
		} else {
			$(newLine).find('[data-cart-item-variant_options]').remove();
		}

		// item line extra properties
		if (item.properties) {
			let propertiesContainer = $(newLine).find('[data-cart-item-properties]');
			if (propertiesContainer.length>0) {
				//console.log(optionsContainer.length);
				let propertyTemplate = propertiesContainer.find('[data-cart-item-property]').detach();
				if (propertyTemplate) {
					let newProperty;
					for (propID in item.properties) {
						newProperty = propertyTemplate.clone().appendTo(propertiesContainer);
						$(newProperty).html(propID + ': ' + item.properties[propID]);
					}
				}
			}
		} else {
			$(newLine).find('[data-cart-item-properties]').remove();
		}

		$(newLine).find('[data-cart-item-quantity_group] [data-type=minus]').click(function(event) {
			event.preventDefault();
			shpCustom.setQuantity(this,-1);
		});
		$(newLine).find('[data-cart-item-quantity_group] [data-type=plus]').click(function(event) {
			event.preventDefault();
			shpCustom.setQuantity(this,1);
		});
		$(newLine).find('[data-cart-item-quantity_group] [data-type=remove]').click(function(event) {
			event.preventDefault();
			shpCustom.cartItemRemove(this);
		});

		$(newLine).find('[data-cart-item-original-price]').html(moneyFormat.replace('{{amount}}',numeral(item.original_price/100).format('0,0.00')));
		$(newLine).find('[data-cart-item-regular-price]').html(moneyFormat.replace('{{amount}}',numeral(item.original_price/100).format('0,0.00')));
		$(newLine).find('[data-cart-item-final-price]').html(moneyFormat.replace('{{amount}}',numeral(item.final_price/100).format('0,0.00')));
	
		$(newLine).removeClass('cartLineTemplate');	
	},

}

$(document).ready(function() {
	shpCustom.init();
});